import { Minus, Plus } from '@components/MiscComponents';
import { color, font } from '@design/templateFns';
import { getFooterTestId } from '@util/getTestIds';
import { Collapse, CollapseProps } from 'antd';
import { FC, Fragment, useState } from 'react';
import styled from 'styled-components';

export interface AccordionProps {
  content: any;
  // update the any later, this was for testing purposes
}

export const Accordion: FC<AccordionProps> = ({ content }) => {
  const [modal, openModal] = useState(false);

  const showModal = () => {
    openModal(!modal);
  };
  const handleOpenModal = () => {
    document.addEventListener('click', showModal);
  };

  // Define the items array based on the content prop
  const items: CollapseProps['items'] = content.map((items: any, index) => {
    return {
      key: index.toString(),
      label: items[0].fields.text,
      'data-testid': getFooterTestId(items[0].fields.text, 0),
      children: (
        <Fragment key={`accordion-${index}`}>
          {items.map(
            (x: any, itemIndex) =>
              itemIndex != 0 && (
                <StyledDiv key={`acc-div-${x.sys.id}`}>
                  <StyledLink
                    href={x.fields.url}
                    data-testid={getFooterTestId(x.fields.text, itemIndex)}
                    key={`a-${x.sys.id}`}
                  >
                    {x.fields.text}
                  </StyledLink>
                </StyledDiv>
              ),
          )}
        </Fragment>
      ),
    };
  });

  return (
    <StyledContainer>
      <Collapse
        items={items} // Pass the items array to the Collapse component
        accordion
        expandIconPosition="end"
        ghost={true}
        expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  .ant-collapse-header {
    padding: 17px 0px !important;
    color: ${color('fg')};
    ${font('subhead-xs')};
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  .ant-collapse-content-box {
    ${font('body-sm-light')};
    color: ${color('fg')};
    padding: 12px 0px !important;
  }

  .ant-collapse-item {
    border-bottom: solid 1px #d4d4d4;
    position: relative;
    border-radius: 0 !important;
  }
  }
`;

const StyledDiv = styled.div`
  padding-bottom: 10px;
`;

const StyledLink = styled.a`
  color: black;
  text-decoration: none;

  &:hover {
    color: grey;
    transition: color 0.2s ease-in-out;
  }
`;
